module.exports = __webpack_public_path__ + "static/media/plCredits.a1301058.png";